import { RequestExceptionWithResponse } from '@eika-infrastruktur/request';

const serviceErrors = [
    'BANK_DISABLED',
    'CIRCUIT_BREAKER_OPEN',
    'BANK_CORE_SERVICE_UNAVAILABLE',
    'BANK_CORE_SERVICE_SYSTEM_ERROR',
];
export default (error: RequestExceptionWithResponse) => {
    return serviceErrors.includes(error.errorName);
};
